/**
 * Versão do site (ex.: "0.2.0 · 12/10/2026 21:40"), escrita no build por
 * scripts/empacotar-hostinger.mjs (vite.config.ts → __VERSAO__). No computador: "dev".
 * Aparece no rodapé e vai junto em cada relato, para saber em qual versão o problema apareceu.
 *
 * Lê: nada.
 * Usado por: App.tsx e componentes/BotaoRelatar.tsx.
 */
declare const __VERSAO__: string | undefined;

export const VERSAO_DO_SITE: string = typeof __VERSAO__ === 'string' ? __VERSAO__ : 'dev';
